module.exports = __webpack_public_path__ + "img/collected-icon.959e625.png";